export default {
  name: "Login"
};